/**
 * Script officiel UTMify (suivi UTM + pixel).
 *
 * IMPORTANT : renseignez UTMIFY_PIXEL_ID avec l'identifiant fourni dans votre
 * tableau de bord UTMify. Tant qu'il est vide, seul le script de suivi UTM est
 * chargé — le script pixel n'est PAS injecté, car un identifiant invalide fait
 * planter pixel.js (« undefined is not an object (evaluating 'lead._id') »).
 */

const UTMIFY_PIXEL_ID = ''

declare global {
  interface Window {
    pixelId?: string
  }
}

let loaded = false

export function loadUtmify(): void {
  if (loaded || typeof document === 'undefined') return
  loaded = true

  // UTMify — suivi des paramètres UTM (aucun identifiant requis)
  const utmScript = document.createElement('script')
  utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
  utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
  utmScript.setAttribute('data-utmify-prevent-subids', '')
  utmScript.async = true
  utmScript.defer = true
  document.head.appendChild(utmScript)

  // UTMify Pixel — uniquement si un identifiant réel est configuré
  if (!UTMIFY_PIXEL_ID) return

  window.pixelId = UTMIFY_PIXEL_ID
  const pixelScript = document.createElement('script')
  pixelScript.async = true
  pixelScript.defer = true
  pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
  document.head.appendChild(pixelScript)
}
